/**
 * Optional padding on .lay-text-line-mask when data-line-mask-padding-bottom is set on .lay-text-animation
 * (masked_lines / masked_words in the gridder).
 */
export function applyLineMaskPaddingBottomStyle(maskWrapper, animationRoot) {
	if (!maskWrapper || !animationRoot) return
	const v = animationRoot.getAttribute('data-line-mask-padding-bottom')
	if (v === 'true' || v === '1') {
		maskWrapper.style.paddingBottom = '0.1em'
	}
}
